<template>
  <div :class="`form-element form-${type}-element`">
    <v-file-input
      v-model="file"
      :label="options.title"
      :multiple="options.multiple"
      :chips="options.multiple"
      prepend-icon="mdi-camera"
      accept="image/*"
      :required="options.required"
      hide-details
      @click="clickFileInput"
    >
      <template v-slot:label>
        <FormLabel
          input-label
          :required="options.required"
          :title="options.title"
          :filled="!!file"
          :field-type="type"
        />
      </template>
      <template v-slot:selection="{ text, index }">
        <v-chip
          label
          color="primary"
        >
          {{ value instanceof Array ? (value[index].customFilename || text) : (value.customFilename || text) }}
          <v-btn
            v-if="(value[index] && value[index].blob) || (value && value.blob)"
            icon
            dark
            @click="editFilename($event, index)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-chip>
      </template>
    </v-file-input>
    <v-dialog
      v-model="dialogOpen"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t('form.elements.image.mode') }}
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="dialogOpen = false; takePicture('gallery')"
          >
            {{ $t('form.elements.image.gallery') }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="dialogOpen = false; takePicture('camera')"
          >
            {{ $t('form.elements.image.camera') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="changeFilenameDialog"
      max-width="290px"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-text-field
            v-model="changeFilenameName"
            :label="$t('form.elements.file.filename')"
            />
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="saveFilename"
          >
          {{ $t('misc.save') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="changeFilenameDialog = false"
          >
          {{ $t('misc.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import moment from 'moment';
import FormLabel from '../FormLabel';

export default {
  components: {
    FormLabel
  },
  props: {
    value: { type: [Object, File], default: () => ({}) },
    type: { type: String, required: true },
    options: { type: Object, default: () => ({}) }
  },
  data: () => ({
    dialogOpen: false,
    file: null,
    currentFileSet: false,
    changeFilenameDialog: false,
    changeFilenameIdx: '',
    changeFilenameName: ''
  }),
  watch: {
    value: {
      immediate: true,
      handler: async function (v) {
        if (!this.file && v && v.name) {
          this.currentFileSet = true;
          this.file = { name: v.name };
        } else if (!this.file && v && v instanceof Array) {
          this.file = [];
          for (let file of v) {
            if (file && file.name) {
              this.currentFileSet = true;
              this.file.push({ name: file.name });
            }
          }
        }
      }
    },
    async file (file) {
      if (this.currentFileSet) {
        this.currentFileSet = false;
        return;
      }

      if (file instanceof Array) {
        if (file.length > 1) {
          let value = [];
          for (let cFile of file) {
            const ab = await cFile.arrayBuffer();

            value.push({
              blob: new Blob([ab], { type: cFile.type }),
              name: cFile.name
            });
          }

          this.$emit('input', value);
          return;
        }

        file = file[0];
      }

      if (!file.blob && file) {
        file = {
          blob: new Blob([file],{type: file.type}),
          name: file.name
        };
      }

      this.$emit('input', file);
    }
  },
  methods: {
    clickFileInput (e) {
      if (!global.isWeb || this.options.mode === 'camera') {
        e.preventDefault();

        if (this.options.mode !== 'camera' && this.options.mode !== 'gallery') {
          this.dialogOpen = true;
        } else {
          this.takePicture(this.options.mode);
        }
      }
    },
    async takePicture (mode) {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.DataUrl,
        source: (mode === 'camera') ? CameraSource.Camera : CameraSource.Photos
      });
      // image.webPath will contain a path that can be set as an image src.
      // You can access the original file using image.path, which can be
      // passed to the Filesystem API to read the raw data of the image,
      // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)

      const blob = await fetch(image.dataUrl).then(r => r.blob());

      this.file = {
        blob,
        name: moment().format('YYYY-MM-DD hh:mm:ss') + '.' + image.format
      };
    },
    editFilename(e, idx) {
      e.stopImmediatePropagation();

      this.changeFilenameIdx = idx;
      if (this.value instanceof Array) {
        this.changeFilenameName = this.value[idx].name;
      } else if (this.value) {
        this.changeFilenameName = this.value.name;
      }

      this.changeFilenameDialog = true;
    },
    saveFilename() {
      this.changeFilenameDialog = false;
      if (!this.changeFilenameName) {
        return;
      }

      if (this.value instanceof Array) {
        this.value[this.changeFilenameIdx].customFilename = this.changeFilenameName;
        this.$emit('input', this.value);
      } else if (this.value) {
        this.value.customFilename = this.changeFilenameName;
        this.$emit('input', this.value);
      }
    }
  }
};
</script>
